module.exports = __webpack_public_path__ + "static/icon_contatti_chat-00d6d1e8b87e7d8e66ee304fb8c94f20.svg";